import axios from 'axios';

const API_BASE_URL = 'http://localhost:8080/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const pictureApi = {
  getAll: () => api.get('/pictures'),
  getById: (id) => api.get(`/pictures/${id}`),
  getByCategory: (category) => api.get(`/pictures/category/${category}`),
  getByTag: (tag) => api.get(`/pictures/tag/${tag}`),
  create: (picture) => api.post('/pictures', picture),
  update: (id, picture) => api.put(`/pictures/${id}`, picture),
  delete: (id) => api.delete(`/pictures/${id}`),
  upload: (formData) => {
    const uploadApi = axios.create({
      baseURL: API_BASE_URL,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return uploadApi.post('/pictures/upload', formData);
  },
  getImage: (id) => `${API_BASE_URL}/pictures/${id}/image`,
};

export const testimonialApi = {
  getAll: () => api.get('/testimonials'),
  getById: (id) => api.get(`/testimonials/${id}`),
  getByTourType: (tourType) => api.get(`/testimonials/tour/${tourType}`),
  create: (testimonial) => api.post('/testimonials', testimonial),
  update: (id, testimonial) => api.put(`/testimonials/${id}`, testimonial),
  delete: (id) => api.delete(`/testimonials/${id}`),
};

export const contactApi = {
  submit: (contact) => api.post('/contact', contact),
};

export default api;
